import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Groups
export const createGroup = (data) => axios.post(`${API}/groups`, data);
export const getGroups = () => axios.get(`${API}/groups`);
export const getGroup = (id) => axios.get(`${API}/groups/${id}`);
export const addGroupMember = (groupId, email) => axios.post(`${API}/groups/${groupId}/members?email=${email}`);

// Expenses
export const createExpense = (data) => axios.post(`${API}/expenses`, data);
export const getExpenses = () => axios.get(`${API}/expenses`);
export const getExpense = (id) => axios.get(`${API}/expenses/${id}`);
export const updateExpense = (id, data) => axios.put(`${API}/expenses/${id}`, data);
export const deleteExpense = (id) => axios.delete(`${API}/expenses/${id}`);

// OCR
export const scanReceipt = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return axios.post(`${API}/ocr/scan`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

// Settlements
export const createSettlement = (data) => axios.post(`${API}/settlements`, data);
export const getSettlements = () => axios.get(`${API}/settlements`);

// Balances
export const getBalances = () => axios.get(`${API}/balances`);

// Dashboard
export const getDashboard = () => axios.get(`${API}/dashboard`);

// Users
export const searchUsers = (q) => axios.get(`${API}/users/search?q=${q}`);

// Profile
export const updateProfile = (data) => axios.put(`${API}/auth/profile`, data);
export const changePassword = (data) => axios.put(`${API}/auth/password`, data);

// Analytics
export const getAnalytics = () => axios.get(`${API}/analytics`);

// Email
export const sendSplitRequest = (data) => axios.post(`${API}/send-split-request`, data);
